import { api } from 'domains/api';
import { PrefilledSignupAppointment, PrefilledSignupAppointmentRaw } from './types';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';

export const getSignupAppointment = (rid: number): Promise<PrefilledSignupAppointment | undefined> => {
  return api.baseAnonymous
    .get<PrefilledSignupAppointmentRaw>(
      getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.appointments.reservation[':rid'], {
        rid,
      }),
    )
    .then(data => {
      if (data.valid) {
        return {
          ...data,
          appointmentTime: new Date(data.appointmentTime),
          appointmentID: rid,
        };
      } else {
        return undefined;
      }
    })
    .catch(() => {
      return undefined;
    });
};
